<template>
  <div class="searchbox-wrapper"></div>
</template>
<script>
/**
 * This fix prevents the keyword input glitch.
 * I had to pull the component out from the Vue and use an extenral input,
 * with this approach Vue doesn't control the input, and do not rewrite input from stale requests.
 */
import { createWidgetMixin } from 'vue-instantsearch';
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import jQuery from 'jquery';

export default {
  name: 'BufferedSearchBox',

  mixins: [createWidgetMixin({ connector: connectSearchBox })],

  props: {
    placeholder: {
      type: String,
      default: '',
    },
    debounceTime: {
      type: Number,
      default: 300,
    },
  },

  data() {
    return {
      localQuery: '',
      isTyping: false,
      timer: null,
    };
  },

  watch: {
    state(newState) {
      const query = newState.query || '';

      if (!this.isTyping && query !== this.localQuery) {
        this.localQuery = query;
      }
    },
  },

  mounted() {
    this.localQuery = (this.state && this.state.query) || '';

    const that = this;
    const value = new URL(window.location.href).searchParams.get('query') || '';

    let $ = jQuery;

    $('.searchbox-wrapper')
      .html(`<input type="text" id="ssws-buffer-input" value="${value}">
                                  <span id="ssws-buffer-input-clear" style="display:${value.trim() === '' ? 'none' : 'block'}">X</span>`);

    const input = document.getElementById('ssws-buffer-input');
    const clear = document.getElementById('ssws-buffer-input-clear');

    if (!input) return;

    let timer = null;

    input.addEventListener('input', (e) => {
      const value = e.target.value;

      if (value.trim() === '') {
        clear.style.display = 'none';
      } else {
        clear.style.display = 'block';
      }

      clearTimeout(timer);
      timer = setTimeout(() => {
        that.state.refine(value);
      }, 300);
    });

    // Handle clear
    clear.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
